// eslint-disable-next-line no-undef
jQuery(document).ready(($) => {
  /* IE popup
  ========================================================================== */

  function checkIfIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
      // eslint-disable-next-line no-alert
      alert(
        "For an optimal viewing experience, please choose a different browser."
      );
    }

    return false;
  }

  checkIfIE();

  /* Set VW without horizontal scrollbar
  ========================================================================== */

  function setVw() {
    const vw = document.documentElement.clientWidth / 100;
    document.documentElement.style.setProperty("--vw", "".concat(vw, "px"));
  }

  window.addEventListener("resize", () => {
    setVw();
  });

  setVw();

  /* Homepage Slider
  ========================================================================== */

  $(".homepage-depot-header__slider").slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
  });

  /* AOS
  ========================================================================== */

  const myPromise = new Promise((resolve, reject) => {
    document.querySelectorAll(".aos").forEach((el) => {
      el.className.split(/\s+/).map((item) => {
        if (item.includes("aos_")) {
          const parts = item.split("_");

          if (parts.length > 2) {
            el.setAttribute(`data-aos-${parts[1]}`, parts[2]);
          } else {
            el.setAttribute("data-aos", parts[1]);
          }
        }
      });
    });

    if (window.innerWidth <= 768) {
      $("[data-aos-delay]").attr("data-aos-delay", "100");
    }

    setTimeout(() => {
      resolve();
    }, 100);
  })
    .then(() => {
      AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
        initClassName: "aos-init", // class applied after initialization
        animatedClassName: "aos-animate", // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 200, // offset (in px) from the original trigger point
        delay: 100, // values from 0 to 3000, with step 50ms
        duration: 400, // values from 0 to 3000, with step 50ms
        easing: "ease", // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
      });
    })
    .catch((error) => {
      console.log(error);
    });

  /* Odometer
  ========================================================================== */

  $(document).on("aos:in:stats-animated", ({ detail }) => {
    $(detail)
      .find(".stats__odometer")
      .each((i, el) => {
        const oldStats = $(el).text();

        new Odometer({
          el,
          value: 0,
          theme: "default",
        }).update(oldStats);
      });
  });

  /* Depots map
  ========================================================================== */

  $(document).on("click", "#Depots > g", (e) => {
    $("#Depots >g.selected").removeClass("selected");

    const depot = $(e.currentTarget)
      .first()
      .addClass("selected")
      .attr("id")
      .replace("_", " ");

    const { logo } = CONTACT_DETAILS[depot];
    const { address } = CONTACT_DETAILS[depot];
    const { email } = CONTACT_DETAILS[depot];
    const { phone } = CONTACT_DETAILS[depot];
    const { path } = CONTACT_DETAILS[depot];
    const url = `https://${path}`;

    $(".depots-map__contact-details").fadeOut(300, () => {
      if (depot === "Buslines Group") {
        $(".depots-map__contact-details").removeClass("is_depot");
        $(".depots-map__icon-fax").show();
        $(".depots-map__text-fax").show();
      } else {
        $(".depots-map__contact-details").addClass("is_depot");
        $(".depots-map__icon-fax").hide();
        $(".depots-map__text-fax").hide();
      }

      $(".depots-map__icon-logo > img ").attr("src", logo);
      $(".depots-map__text-address").html(address);
      $(".depots-map__text-email").html(
        `<a href="mailto:${email}">${email}</a>`
      );
      $(".depots-map__text-phone").html(
        `Telephone: <a href="tel:${phone}">${phone}</a>`
      );
      $(".depots-map__text-url").html(
        `<a target="_blank" href="${url}">${path}</a>`
      );
      $(".depots-map__text-feedback").html(
        `<a href="/contact-us/feedback?depot=${depot}">Click here</a>`
      );

      setTimeout(() => {
        $(".depots-map__contact-details").fadeIn(300);
      }, 300);
    });
  });

  /* Google map
  ========================================================================== */

  // Render maps on page load.
  $(".google-map").each(function () {
    const map = initMap($(this));
  });

  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    const $markers = $el.find(".marker");

    // Create gerenic map.
    const mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      streetViewControl: false,
      keyboardShortcuts: false,
      fullscreenControl: false,
      styles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#e8f6ff",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              color: "#7ecfff",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#0e7cbe",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#e8f6ff",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#b6e4ff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c7eaff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#27a5ee",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#bbe6ff",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#b6e4ff",
            },
          ],
        },
      ],
    };
    const map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    const lat = $marker.data("lat");
    const lng = $marker.data("lng");
    const latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    const marker = new google.maps.Marker({
      position: latLng,
      map,
      icon: "/wp-content/uploads/2021/08/Marker.png",
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      const infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", () => {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    const bounds = new google.maps.LatLngBounds();
    map.markers.forEach((marker) => {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  /* Floating form
  ========================================================================== */

  $(".floating-form__trigger").on("click", () => {
    $(".floating-form__container").fadeToggle();
  });

  /* Hide TfNSW trip planner once the sidebar is longer than main content
  ========================================================================== */

  /*  if ($("#main").innerHeight() - $(".inside-right-sidebar").innerHeight() < 0) {
    $(".tfnsw.widget").hide();
  } */

  /* School services nav
  ========================================================================== */

  /* if ($(".school-services-nav").length > 0) {
    $(".tag-depot-school-services > .inside-article > section").each(
      (index, element) => {
        let id = $(element).attr("id");
        let name = $(element).find("h2").text();
        $(".school-services-nav__items").html(
          $(".school-services-nav__items").html() +
            `<a href="#${id}" class="smooth-scroll">
					<li class="school-services-nav__item">
						<h4 class="school-services-nav__item-title">
						${name}
						</h4>
					</li>
				</a>`
        );
      }
    );
  } */

  /* Job vacancy toggle
  ========================================================================== */

  $(".job-vacancy__more").on("click", function () {
    $(this).toggleClass("open").next(".job-vacancy__details").slideToggle();
  });

  /* Accordion
  ========================================================================== */

  $(".accordion").on("click", function () {
    $(this).toggleClass("active").next(".panel").slideToggle();
  });

  /* Versioning all pdf links
  ========================================================================== */

  if ($("a[href$='.pdf']").length) {
    /*   $("a[href$='.pdf']").attr(
      "href",
      $(this).attr("href") + "?v=" + new Date().getTime()
    ); */
    $("a[href$='.pdf']").each(function () {
      $(this).attr("href", `${$(this).attr("href")}?v=${new Date().getTime()}`);
    });
  }
});
